<template>
  <section>
    <!-- Different views of the homepage, e.g. 'Classic', 'Selling', or 'Story' -->
    <component :is="viewCompoment" />

    <Chat />
  </section>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import UserJS from '@/objects/UserObject';
import Chat from '@/components/chats/Chat';

function loadView(viewName) {
  return () =>
    import(
      /* webpackChunkName: "[request]" */
      `@/components/homepage/viewTypes/${viewName}.vue`
    );
}

export default {
  name: 'Homepage',
  components: {
    Chat,
    ClassicView: loadView('ClassicView'),
    SellingView: loadView('SellingView'),
    StoryView: loadView('StoryView'),
    ProfessionalView: loadView('ProfessionalView'),
    PromotionsView: loadView('PromotionsView'),
  },

  computed: {
    partnerGroupId() {
      return this.$store.getters['Account/partnerGroupDetails'].PartnerGroupId;
    },
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    viewType() {
      // 'Classic' | 'Selling' | 'Story' | 'Professional' | 'ProfessionalBeta' | 'Luxury'
      console.log('VIEW TYPE: ', this.$store.getters['Account/partnerGroupDetails'].ViewType);
      return this.$store.getters['Account/partnerGroupDetails'].ViewType;
    },
    viewCompoment() {
      switch (this.viewType) {
        case 'Classic':
          return 'ClassicView';
        case 'Selling':
          return 'SellingView';
        case 'Story':
          return 'StoryView';
        case 'Professional':
          return 'SellingView';
        case 'ProfessionalBeta':
          return 'ProfessionalView';
        case 'Luxury':
          return 'PromotionsView';
        default:
          return 'ClassicView';
      }
    },
  },
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
    this.scrollTo();

    addLog(
      UserJS.getUserObjectId(),
      this.partnerGroupId,
      'PartnerGroup',
      'Homepage',
      -1,
      10
    );
  },
  updated() {
    this.scrollTo();

    window.EventBus.fire(
      'updateMetaData',
      this.$store.getters['Account/metaData']
    );
  },
  methods: {
    init() {
      UserJS.getPromotions();
    },
    scrollTo() {
        console.log('Going to scroll ...');
        if (
          this.$route.params.scrollTo != null &&
          this.$route.params.scrollTo !== ''
        ) {
          // Scroll to specified element
          this.srollToElementById(this.$route.params.scrollTo);

          this.$route.params.scrollTo = '';
        }
        else if (
          this.$store.getters.getScrollDirectlyToItems  &&
          !this.breakpointSmAndDown && this.viewType === 'Luxury'
        ) {
          this.srollToElementById('allCategories');
        }
        else if (
          this.$store.getters.getScrollDirectlyToItems &&
          !this.breakpointSmAndDown
        ) {
          // Scroll to Promotions section
          this.srollToElementById('promotions');
        }
        else {
          window.scrollTo(0, 0);
      }
    },
    srollToElementById(id) {
      const elId = `#${id}`;
      const scrollToElement = document.querySelector(elId);
      if (scrollToElement != null) {
        this.$vuetify.goTo(elId);
      }
    },
  },
};
</script>

<!--not scoped css style for children element of homepage-->
<style lang="scss">
.titleFontSize {
  font-size: 2.5vw !important;
}
.itemTitleFontSize {
  @media only screen and (max-width: 1264px) {
    font-size: 17px;
  }
}
</style>
